(function(){
    'use strict';

    angular
       .module('appback')
       .factory('LocalizadorService', LocalizadorService);

   LocalizadorService.$inject = ['$http'];

   function LocalizadorService($http){


       var service= {
          getCuentas:getCuentas
       };

       return service;
       function getCuentas(vm, startDate, endDate, map) {

            var config = { headers: {} }
            // offset:vm.offset, page:vm.page, limit:vm.limit,
            var url = '/backend/cuenta/getcuentas';
           
            
            return $http.get(url, {
                params: {
                    currentPage: vm.currentPage,
                    filtros: JSON.stringify(vm.filtros)
                }
            }, config).then(function (data) {
                console.log(data)
                return data.data;
            }, function (data) {
                console.log(data)
                return data;
            });


        };

     


   }
})();